module.exports = __webpack_public_path__ + "img/purple-circle-table-5.08ab2a6f.png";